import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  CREATE_NON_INVENTORY: `${SLICE_NAME}/create_non_inventory`,
  UPDATE_NON_INVENTORY: `${SLICE_NAME}/update_non_inventory`,
  DELETE_NON_INVENTORY: `${SLICE_NAME}/delete_non_inventory`,
  RETRIEVE_NON_INVENTORY: `${SLICE_NAME}/get_non_inventory`,
  RETRIEVE_MANY_NON_INVENTORY: `${SLICE_NAME}/get_many_non_inventory`,
} as const;
